import React from 'react';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';

import ContentContainer from './ContentContainer';
import DetailsLink from './DetailsLink';
import { getApplicationViewData } from './util';
import { applicationConstants } from '../../../../constants/applicationConstants';
import EmployeeCell from '../EmployeeCell';

const ActiveContent = () => (
  <ContentContainer>
    {(items, user) => (
      <React.Fragment>
        <TableHead>
          <TableRow>
            <TableCell>№ заявления</TableCell>
            <TableCell>№ бланка</TableCell>
            <TableCell>Дата активации</TableCell>
            <TableCell>Организация / ФИО</TableCell>
            <TableCell>Сотрудник, активировавший разрешение</TableCell>
            <TableCell numeric>Осталось/всего поездок</TableCell>
            <TableCell numeric>Действие</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map(application => {
            const viewData = getApplicationViewData(
              application,
              applicationConstants.STATUS_ACTIVE,
              user
            );
            return (
              <TableRow key={viewData.id}>
                <TableCell>{viewData.appNumber}</TableCell>
                <TableCell>{viewData.formNumber}</TableCell>
                <TableCell>{viewData.createdAt}</TableCell>
                <EmployeeCell userName={viewData.userName} application={application} />
                <TableCell>{viewData.eventUser}</TableCell>
                <TableCell numeric>{viewData.runsLeft} / {viewData.runsTotal}</TableCell>
                <TableCell numeric className="nowrap">
                  <DetailsLink user={user} item={application} />
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </React.Fragment>
    )}
  </ContentContainer>
);

export default ActiveContent;
